export default "__VITE_ASSET__dca398c6__"